// Personal data

export enum CustomerSource {
  DIGITAL = 'digital',
  RETAIL = 'retail',
  REFERRAL = 'referral',
  FAMILY_AND_FRIENDS = 'family_and_friends',
  CORPORATE = 'corporate'
}

export enum CustomerChannelDigitalSource {
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  WEBSITE = 'website',
  DUBIZZLE = 'dubizzle',
  PHONE_CALL = 'phone_call',
  GOOGLE = 'google',
  WHATSAPP = 'whatsapp'
}

export enum HearAboutUsOptions {
  SOCIAL_MEDIA = 'Social media',
  WEBSITE_AD = 'Website ad',
  MERCHANT = 'Merchant',
  FRIENDS = 'Friends',
  OTHERS = 'Others'
}

export enum CustomerSourceOptions {
  DIGITAL = 'digital',
  RETAIL = 'retail',
  REFERRAL = 'referral',
  FAMILY_AND_FRIENDS = 'family_and_friends',
  CORPORATE = 'corporate'
}

export enum IdentityOptions {
  ID = 'id',
  PASSPORT = 'passport'
}

export enum GenderOptions {
  MALE = 'male',
  FEMALE = 'female'
}

export enum JobStatusOptions {
  IN_SERVICE = 'in_service',
  RETIRED = 'retired',
  UNEMPLOYED = 'unemployed'
}

export enum MaritalStatusOptions {
  SINGLE = 'single',
  MARRIED = 'married',
  DIVORCED = 'divorced'
}

export enum PaymentTypeOptions {
  CASH = 'cash',
  INSTALLMENT = 'installment'
}

export enum ResidentialTypeOptions {
  STUDIO = 'studio',
  APPARTMENT = 'appartment',
  TWIN_HOUSE = 'twin_house',
  VILLA = 'villa'
}

export enum ResidentialUnitAreaOptions {
  '50_100' = '50 - 100 m²',
  '101_200' = '101 - 200 m²',
  '201_500' = '201 - 500 m²',
  'Above_500' = 'Above 500 m²'
}

export enum ResidenceTypeOptions {
  RENTAL = 'rental',
  OWNED = 'owned'
}

export enum RentalTypeOptions {
  OLD = 'old',
  NEW = 'new'
}

export enum UtilityBillTypeOptions {
  ELECTRICITY = 'electricity',
  WATER = 'water',
  GAS = 'gas',
  PHONE = 'phone'
}

export enum ResidentialStayDurationOptions {
  'LESS_THAN_1_YEAR' = 'Less than 1 year',
  '1_2_YEARS' = '1 - 2 years',
  '2_5_YEARS' = '2 - 5 years',
  'MORE_THAN_5_YEARS' = 'More than 5 years'
}

export enum ReferenceRelationOptions {
  FATHER = 'father',
  MOTHER = 'mother',
  SISTER = 'sister',
  BROTHER = 'brother',
  HUSBAND = 'husband',
  WIFE = 'wife',
  SON = 'son',
  DAUGHTER = 'daughter',
  UNCLE = 'uncle',
  FRIEND = 'friend'
}
// Financial data

export enum IncomeTypeOptions {
  TIME_DEPOSIT = 'time_deposit',
  ASSETS = 'assets',
  PART_TIME_JOB = 'part_time_job',
  OTHER = 'other'
}

export enum CommercialRegisterTypeOptions {
  SAE = 'sae',
  LLC = 'llc',
  INDIVIDUAL = 'individual'
}

export enum OfficeClinicOwnershipTypeOptions {
  RENTAL_SHARED = 'rental_shared',
  FULLY_OWNED = 'fully_owned'
}

// Pickup data

export enum RegionOptions {
  HOME = 'home',
  WORK = 'work'
}

export enum CareerLevel {
  EXECUTIVE = 'executive_or_senior_management',
  SENIOR_MANAGER = 'middle_management',
  MANAGER = 'first-level_management',
  SENIOR = 'intermediate_or_experienced',
  ENTRY = 'entry_level'
}

export enum OrganizationSectors {
  AUTOMOTIVE = 'Automotive',
  CHEMICALS_AND_SPECIALITY_MATERIALS = 'chemicals_and_speciality_materials',
  CONSUMER_PRODUCTS = 'consumer_products',
  INDUSTRIAL_PRODUCTS_AND_SERVICES = 'industrial_products_and_services',
  RETAIL_WHOLESALE_AND_DISTRIBUTION = 'retail_wholesale_and_distribution',
  TRAVEL_HOSPITALITY_AND_SERVICES = 'Travel, Hospitality and Services',
  ENERGY_RESOURCES = 'energy_resources',
  MINING = 'mining',
  OIL_GAS = 'oil_gas',
  POWER = 'power',
  SHIPPING_PORTS = 'shipping_ports',
  WATER = 'Water',
  BANKING_SECURITIES = 'banking_securities',
  INSURANCE = 'insurance',
  INVESTMENT_MANAGEMENT = 'investment_management',
  REAL_ESTATE = 'real_estate',
  HEALTH_CARE = 'health_care',
  LIFE_SCIENCES = 'life_sciences',
  PUBLIC_SECTOR = 'public_sector',
  CIVIL_GOVERNMENT = 'civil_government',
  DEFENSE = 'defense',
  EDUCATION = 'education',
  INTERNATIONAL_DONOR_ORGANIZATIONS = 'international_donor_organizations',
  PUBLIC_HEALTH_AND_SOCIAL_SERVICES = 'public_health_and_social_services',
  PUBLIC_TRANSPORTATION = 'public_transportation',
  SECURITY_AND_JUSTICE = 'Security and Justice',
  TECHNOLOGY = 'technology',
  MEDIA = 'media',
  TELECOMMUNICATIONS = 'telecommunications'
}

export enum CustomerDocs {
  idFront = 'ID front',
  idBack = 'ID back',
  passportFront = 'Passport front',
  residencyClearance = 'Residency clearance',
  residentialContract = 'Residential contract',
  utilityBill = 'Utility bill',
  bankStatement = 'Bank statement',
  hrLetter = 'HR letter',
  timeDeposit = 'Time Deposit',
  assetContract = 'Asset contract',
  otherAmountReceipt = 'Other amount receipt',
  commercialRegister = 'Commercial register',
  taxId = 'Tax ID',
  associationMemorandum = 'Association memorandum',
  carLicenseFront = 'Car license front',
  carLicenseBack = 'Car license back',
  drivingLicenseFront = 'Driving license front',
  drivingLicenseBack = 'Driving license back',
  clubId = 'Club ID',
  medicalCard = 'Medical card',
  workId = 'Work ID',
  other = 'Other'
}

export enum DigitalSourceOptions {
  DIRECT = 'Direct',
  DIGITAL_REFERRAL = 'Digital referral'
}
